import ROUTE_NAMES from '@/app/admin/router/router-const';

export default [
  {
    path: 'cbr_accounts',
    name: ROUTE_NAMES.CBR_ACC,
    component: () => import('../CbrAccountsPage.vue'),
  }
];